/**
 * Created with IntelliJ IDEA.
 * User: mozartdiniz
 * Date: 7/24/13
 * Time: 2:11 PM
 * To change this template use File | Settings | File Templates.
 */



Monet.UI = Monet.UI || {};

Monet.UI.FloatMenu = (function (){

    return function (menuItems, conf) {

        this.el           = document.createElement('div');
        this.el.className = 'MonetUIFloatMenu';
        this.left         = '0';
        this.top          = '0';
        this.menuItems    = menuItems;
        this.conf         = conf;
        this.targetEl     = conf.targetEl || null;
        this.target       = document.querySelector (this.targetEl);
        this.tab          = null;
        this.listProvider = Monet.UI.List;

        this.removeAllMenus = function (customClass) {

            var previousMenu = null;

            if (!this.tab) {
                this.tab = document.getElementById(Monet.Utils.GetTabName());
            }

            previousMenu = this.tab.getElementsByClassName(customClass || 'MonetUIFloatMenu');

            while(previousMenu.length > 0) {
                try {
                    this.tab.removeChild(previousMenu[0]);
                } catch (e) {
                    console.log (e);
                }
            }
        };

        this.render = function (x,y, additionalClass) {

            if (this.menuItems) {

                var list  = this.listProvider;
                list.data = this.menuItems;

                if (conf.description) {
                    list.conf.description = this.conf.description;
                } else {
                    list.conf = {
                        description: 'description'
                    };
                }

                if (typeof conf.addListener === "undefined") {

                    this.conf.addListener = true;

                } else {

                    this.conf.addListener = conf.addListener;

                }

                this.el.innerHTML = "";
                this.el.appendChild(list.render());

                this.tab = document.getElementById(Monet.Utils.GetTabName());

                if (this.tab) {

                    this.tab.appendChild(this.el);

                    const heightRow = 30;
                    const rows = parseInt(this.el.offsetHeight / heightRow, 10);
                    const clazz = additionalClass || '';

                    if((this.el.offsetWidth+40) + x > window.innerWidth){
                        this.el.style.left = (x - (this.el.offsetWidth + 20)) + 'px';
                        this.el.className = `MonetUIFloatMenu MenuRight ${clazz}`;
                    } else {
                        this.el.style.left = (x + 40) + 'px';
                        this.el.className = `MonetUIFloatMenu MenuLeft ${clazz}`;
                    }

                    if (this.el.offsetHeight + y > window.innerHeight) {
                      this.el.style.top = `${y - (this.el.offsetHeight + 65)}px`;
                      this.el.className += ' MenuBottom';
                    } else {
                        this.el.style.top = `${(y - ((this.el.offsetHeight / 2) + 85))}px`;
                        if (this.el.className.indexOf('MenuBottom') !== -1) {
                            this.el.className = this.el.className.replace('MenuBottom', '');
                        }

                    }

                    document.body.addEventListener('keyup', (function (scope) {
                        return function () {
                            if (scope.el.parentNode) {
                                try {
                                    scope.tab.removeChild(scope.el);
                                } catch (e) {
                                    console.log (e);
                                }

                            }
                        };
                    }(this)));

                    if (conf.addListenerToParent) {

                        this.el.parentNode.addEventListener('click', (function (scope) {
                            return function () {
                                if (scope.el.parentNode) {
                                    scope.tab.removeChild(scope.el);
                                }
                            };
                        }(this)));

                    }

                } else {
                    console.log ('Cant found any element (' + this.target + ') to add menu');
                }

            } else {
                console.log ('Your cant create float menu without items');
            }

        };

        this.create = function (e, scope) {
            scope.render(e.clientX, e.pageY);
        };

        this.addListeners = function () {

            this.target.addEventListener('click', (function (scope) {
                return function (e) {
                  e.stopPropagation();
                  scope.create(e, scope);
                };
            }(this)));

        };

        this.init = function () {

            if (this.target) {
                this.addListeners();
            } else {
                console.log ('Cant found any element (' + this.target + ') to add menu');
            }

        };

    };

}());

Monet.UI.Base = function () {

    this.el = null;

    this.addListeners = function () {

    };

    /**
     * Método que adiciona conteúdo no final do elemento
     * @param el elemento onde o coneteúdo vai ser inserido.
     * @param child conteudo a ser inserido, pode ser uma string html, ou um objeto do DOM
     */

    this.appendChild = function (el, child) {

        var _el = el;

        if (_el) {

            if (typeof child === 'string') {
                el.insertAdjacentHTML('beforeEnd', child);
            } else {
                el.appendChild(child);
            }

        }

    };

    this.render = function () {

    };

};

Monet.UI.Sidebar = (function () {

    Sidebar.prototype = new Monet.UI.Base();

    /**
     * Opções para renderizar o sidebar
     * @param options {Object} position: posição da sidebar, left ou rigth.
     * alinhado a esquerda é o default
     * @constructor
     */

    function Sidebar (options) {

        var classList = {
            MonetUISidebarLeft: 'MonetUISidebarLeft',
            MonetUISidebarRight: 'MonetUISidebarRight'
        };

        this.el = document.createElement('div');

        this.el.className = 'MonetUISidebar';
        this.options = {
            position: 'left'
        };

        this.render = function () {

            var error = null;

            try {

                if (options) {
                    this.options = options;
                }

                if (this.options.position !== 'left') {
                    this.el.className += ' ' + classList.MonetUISidebarRight;
                } else {
                    this.el.className += ' ' + classList.MonetUISidebarLeft;
                }

                if(this.fragment){
                    this.el.appendChild(this.fragment);
                }

                return this.el;

            } catch (e) {

                error = new Monet.Exception.ReturnError(this, 'Error on create side bar');
                error.console();
            }

        };

        /**
         * Append content on DOM.
         * @param {DOMObject} content
         */
        this.setContent = function (content) {
           this.el.appendChild(content);
        };

    }

    return Sidebar;

}());

Monet.UI.SidebarTransition = (function () {

    SidebarTransition.prototype = new Monet.UI.Base();

    /**
     * Opções para renderizar o sidebar
     * @param options {Object} position: posição da sidebar, left ou rigth.
     * alinhado a esquerda é o default
     * @constructor
     */

    function SidebarTransition (position) {

        this.el = document.createElement('div');
        var sidebarEffects = new SidebarMenuEffects();
        var preferenceSidebar = '';

        this.render = function () {

            this.checkSideBarPreferenceUser();

            if ( preferenceSidebar.show ) {
                this.el.setAttribute('class', 'st-container ' + 'st-effect-' + position + ' st-menu-open');
            } else {
                this.el.setAttribute('class', 'st-container ' + 'st-effect-' + position + ' st-menu-close');
            }

            this.el.setAttribute('id', 'st-container');

            var divStPusher = document.createElement('div');
            divStPusher.setAttribute('class', 'st-pusher');


            var navMenu = document.createElement('nav');
            navMenu.setAttribute('class', 'st-menu st-effect-' + position);
            navMenu.setAttribute('id', 'menu-' + position);

            divStPusher.appendChild(navMenu);

            var divStContent = document.createElement('div');
            divStContent.setAttribute('class', 'st-content');

            var divStContentInner = document.createElement('div');
            divStContentInner.setAttribute('class', 'st-content-inner');

            var divStTriggerEffects = document.createElement('div');
            divStTriggerEffects.setAttribute('class', 'column');
            divStTriggerEffects.setAttribute('id', 'st-trigger-effects');

            var divTransition = document.createElement('div');
            divTransition.setAttribute('data-effect', 'st-effect-' + position);
            divTransition.setAttribute('id', 'transition');

            if ( preferenceSidebar.show ){
                divTransition.setAttribute('class', 'sideBarClose');
            } else {
                divTransition.setAttribute('class', 'sideBarOpen');
            }

            divTransition.style['float'] = position;

            var divAppendContent = document.createElement('div');
            divAppendContent.setAttribute('class', 'appendContent');

            divStTriggerEffects.appendChild(divTransition);
            divStTriggerEffects.appendChild(divAppendContent);

            divStContent.appendChild(divStTriggerEffects);
            divStContent.appendChild(divStContentInner);
            divStPusher.appendChild(divStContent);
            this.el.appendChild(divStPusher);

            return this.el;

        };

        this.setContentOnMenu = function (content) {
            var menuContent = this.el.querySelector('.st-menu');
            menuContent.appendChild(content);
        };

        this.setContent = function (content) {
            var menuContent = this.el.querySelector('.appendContent');
            menuContent.appendChild(content);
        };

        this.checkSideBarPreferenceUser = function () {
            var storage = new Greenmile.Storage.StoreMapPosition(),
                screen = Monet.Utils.GetTabName();
            var preferenceSideBarOnLocalStorage = storage.getSideBarExpandFromUser();

            if ( preferenceSideBarOnLocalStorage ) {
                for (var i = 0, size = preferenceSideBarOnLocalStorage.length; i < size; i++) {
                   if ( screen === preferenceSideBarOnLocalStorage[i].screen ) {
                       preferenceSidebar = preferenceSideBarOnLocalStorage[i];
                       return;
                   }
                }
            }

            storage.setSideBarExpandFromUser(screen, true);
            preferenceSidebar = {
                screen : screen,
                show : true
            };
        };

        this.init = function() {
            const tabGreenmile = document.querySelector('.gmTabs__tab-bar');
            const headerGreenmile = document.querySelector('header');

            const heightOfContent = window.document.body.scrollHeight - tabGreenmile.offsetHeight -
                headerGreenmile.offsetHeight;

            sidebarEffects.init();

            var divTransition = document.querySelector( '#' + Monet.Utils.GetTabName() + ' #transition');
            divTransition.style.top = (heightOfContent/2 - 10) + 'px';
        };

        this.setCallbackAfterHide = function (callbackAfterHide) {
            sidebarEffects.callbackAfterHide = callbackAfterHide;
        };

        this.setCallbackAfterShow = function (callbackAfterShow) {
            sidebarEffects.callbackAfterShow = callbackAfterShow;
        };

        this.setCallbackBeforeHide = function (callbackBeforeHide) {
            sidebarEffects.callbackAfterHide = callbackBeforeHide;
        };

        this.setCallbackBeforeShow = function (callbackBeforeShow) {
            sidebarEffects.callbackAfterHide = callbackBeforeShow;
        };


    }

    return SidebarTransition;

}());
